import { jsx as _jsx } from "react/jsx-runtime";
import Carousel from "../../components/Carousel";
import SelectableCards from "../../components/InfoCards/SelectableCards";
import { RelatedBlogInfoCards } from "../../components/InfoCards/RelatedBlogInfoCards";
import { INFO_CARD_VARIANTS, CONFIGURATION_TYPE_IDS } from "../../constants";
import { filterConfigs } from "../../functions/helpers";
const CardCarousel = ({ infoCards, configurations }) => {
    const carouselConfig = filterConfigs(configurations, CONFIGURATION_TYPE_IDS.CAROUSEL);
    return _jsx(Carousel, { items: infoCards, config: carouselConfig[0] });
};
const CardGrid = ({ infoCards }) => {
    const columnCount = (infoCards === null || infoCards === void 0 ? void 0 : infoCards.length) < 3 ? infoCards === null || infoCards === void 0 ? void 0 : infoCards.length : 3;
    return _jsx("div", { className: `grid grid-cols-1 lg:grid-cols-${columnCount} gap-md m-auto`, children: infoCards });
};
const SelectableCardGrid = ({ infoCards, ctas }) => {
    return _jsx(SelectableCards, { infoCards: infoCards, ctas: ctas });
};
const RelatedBlogCards = ({ infoCards, configurations }) => {
    const cardConfig = filterConfigs(configurations, CONFIGURATION_TYPE_IDS.INFO_CARD);
    return _jsx(RelatedBlogInfoCards, { infoCards: infoCards, config: cardConfig });
};
export const BannerCardContainer = ({ infoCards }) => {
    return _jsx("div", { className: "flex flex-col gap-6", children: infoCards });
};
const INFO_CARD_DISPLAY_COMPONENT_MAP = {
    [INFO_CARD_VARIANTS.CAROUSEL_CARD]: CardCarousel,
    [INFO_CARD_VARIANTS.CAROUSEL_CARD_VARIANT]: CardCarousel,
    [INFO_CARD_VARIANTS.CONFIGURABLE_CAROUSEL_CARD]: CardCarousel,
    [INFO_CARD_VARIANTS.DEFAULT]: CardGrid,
    [INFO_CARD_VARIANTS.BANNER_CARD]: BannerCardContainer,
    [INFO_CARD_VARIANTS.BANNER_CARD_VARIANT]: BannerCardContainer,
    [INFO_CARD_VARIANTS.SELECTABLE_CARD]: SelectableCardGrid,
    [INFO_CARD_VARIANTS.BLOG_CARD]: RelatedBlogCards,
};
const CONTAINER_TYPE_KEYS = {
    // CAROUSEL: 'Carousel',
    GRID: "Grid",
};
const VARIABLE_TYPE_KEYS = {
    COLUMNS: "Columns",
};
const TAILWIND = {
    [CONTAINER_TYPE_KEYS.GRID]: "grid",
    [VARIABLE_TYPE_KEYS.COLUMNS]: "grid-cols-",
};
export const CardContainer = ({ infoCards, configurations, mobileCardContainerType, cardContainerType, cardVariant, ctas, }) => {
    if (!cardContainerType && !mobileCardContainerType) {
        const InfoCardComponent = INFO_CARD_DISPLAY_COMPONENT_MAP[cardVariant] || INFO_CARD_DISPLAY_COMPONENT_MAP[INFO_CARD_VARIANTS.DEFAULT];
        return _jsx(InfoCardComponent, { infoCards: infoCards, ctas: ctas, configurations: configurations });
    }
    let mobileCardContainerTypeClassNames = "";
    if (mobileCardContainerType) {
        const mobileTypeParts = (mobileCardContainerType === null || mobileCardContainerType === void 0 ? void 0 : mobileCardContainerType.split("-").map(part => part.trim())) || [];
        const mobileMainType = mobileTypeParts[0];
        // @ts-ignore
        mobileCardContainerTypeClassNames += `${TAILWIND[mobileMainType] || ""} `;
        // 1 is the main type
        mobileTypeParts.slice(1).forEach(part => {
            const [value, variable] = part.split(" ");
            if (variable && value) {
                mobileCardContainerTypeClassNames += `${TAILWIND[variable] || ""}${value} `;
            }
        });
    }
    const applyToMobile = mobileCardContainerTypeClassNames.length > 0 ? true : false;
    let containerClassNames = "";
    // split the card container type by -
    const typeParts = (cardContainerType === null || cardContainerType === void 0 ? void 0 : cardContainerType.split("-").map(part => part.trim())) || [];
    const mainType = typeParts[0];
    // @ts-ignore
    containerClassNames += `${applyToMobile ? "md:" : ""}${TAILWIND[mainType] || ""} `;
    // 1 is the main type
    typeParts.slice(1).forEach(part => {
        const [value, variable] = part.split(" ");
        if (variable && value) {
            containerClassNames += `${applyToMobile ? "md:" : ""}${TAILWIND[variable] || ""}${value} `;
        }
    });
    return (_jsx("div", { className: `${mobileCardContainerTypeClassNames} ${containerClassNames}`, children: infoCards.map(card => card) }));
};
